import alt from 'framework/alt';

class AccountActions {
  constructor() {
    this.generateActions(
      'createStarted',
      'createSucceeded',
      'createFailed',
      'completeAccountForLegacyUserStarted',
      'completeAccountForLegacyUserSucceeded',
      'completeAccountForLegacyUserFailed',
    );
  }
}

export default alt.createActions(AccountActions);
